import React, { Component } from 'react';

import { graphql } from "react-apollo";
import BootstrapTable from 'react-bootstrap-table-next';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardBody, CardText, Row, Col, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import { priceFormatter, dateFormatter, periodFormatter } from "../../utils/Formatters";
import paginationFactory from "react-bootstrap-table2-paginator";
import QueryDataGrid from "../QueryDataGrid";
import i18n from '../../views/Pages/Login/i18n';
import { withRouter } from 'react-router';
import Loading from '../Loading';
import NotesAndAttachments from "../../components/NotesAndAttachments"
import {getInvoiceQuery} from "../../queries/Queries"

class ReadingsDetail extends Component {

    downloadInvoice() {
        console.log('download');
    }

    render() {
        var invoiceItems = [];
        return (!this.props.getInvoice.loading && this.props.getInvoice.invoice) ? (
            <div className="invoice-details">
                <Row>
                    <Col sm="12" className="header">
                        <Button onClick={() => this.props.history.push('/bp/'+this.props.match.params.id)} className="btn btn-default"><i className="icon ion-arrow-left-b"></i>{i18n.t('businessPartner.invoice')}:&nbsp;&nbsp;{this.props.getInvoice.invoice.documentNo}</Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <table className="invoice-stats">
                                            <tr>
                                                <td>
                                                    {i18n.t('businessPartner.Invoicedate')}
                                                </td>
                                                <td>
                                                    {dateFormatter(this.props.getInvoice.invoice.invoiceDate,null)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {i18n.t('businessPartner.Duedate')}
                                                </td>
                                                <td>
                                                    {dateFormatter(this.props.getInvoice.invoice.fINPaymentScheduleList[0].dueDate)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {i18n.t('businessPartner.Period')}
                                                </td>
                                                <td>
                                                    {periodFormatter(this.props.getInvoice.invoice.billPeriod)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {i18n.t('businessPartner.Payment')}
                                                </td>
                                                <td className={(this.props.getInvoice.invoice.isPaymentComplete) ? 'paid' : 'unpaid'}>
                                                    {this.props.getInvoice.invoice.isPaymentComplete ? 'Paid' : 'Unpaid'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {i18n.t('businessPartner.outstanding')}
                                                </td>
                                                <td>
                                                    {priceFormatter(this.props.getInvoice.invoice.outstandingAmount, this.props.getInvoice.invoice) }
                                                </td>
                                            </tr>
                                        </table>
                                    </Col>
                                    <Col>
                                        <Button color='info' className="pull-right" onClick={this.downloadInvoice} ><i className="icon ion-android-download"></i>{i18n.t('businessPartner.Download')}</Button>
                                    </Col>
                                </Row>
                                <Row >
                                    <QueryDataGrid className="invoice-table" dataPath={'invoice.invoiceLineList'} keyField={'id'} query={`
                                            query invoiceQuery {
                                            invoice(startRow: 0, offset: 5, where: "id = '${this.props.match.params.billid}'", orderBy: "id") {
                                                        id
                                                        invoiceLineList(startRow: 0, offset: 100, where: "id is not null", orderBy: "id"){
                                                            id
                                                            product{
                                                                name
                                                                mdmPurpose
                                                            }
                                                            invoicedQuantity
                                                            uOM{
                                                                name
                                                            }
                                                            unitPrice
                                                            lineNetAmount
                                                            invoice{
                                                                currency{
                                                                    symbol
                                                                    iSOCode
                                                                }
                                                            }
                                                        }
                                            }
                                        }

                                        ` }
                                        columns={[{
                                            dataField: 'product.mdmPurpose',
                                            text: i18n.t('product.type'),
                                            //sort: true
                                        }, {
                                            dataField: 'product.name',
                                            text: i18n.t('product.name'),
                                            sort: true
                                        }, {
                                            dataField: 'invoicedQuantity',
                                            text: i18n.t('product.quantity'),
                                            sort: true
                                        }, {
                                            dataField: 'uOM.name',
                                            text: i18n.t('product.unit'),
                                            sort: true
                                        }, {
                                            dataField: 'unitPrice',
                                            text: i18n.t('product.price'),
                                            sort: true,
                                            align: "right",
                                            headerAlign: "right",
                                            formatter: priceFormatter
                                        }, {
                                            dataField: 'lineNetAmount',
                                            text: i18n.t('product.total'),
                                            sort: true,
                                            align: "right",
                                            headerAlign: "right",
                                            formatter: priceFormatter
                                        }]}

                                    />
                                </Row>
                                <div className="subtotals" noGutter>
                                    <Row>
                                        <Col sm="6">
                                            Subtotal:</Col>
                                        <Col sm="6">
                                            {priceFormatter(this.props.getInvoice.invoice.invoiceTaxList[0].taxableAmount, this.props.getInvoice.invoice)}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="6">
                                            Discount:
                                            </Col>
                                        <Col className="">

                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="6">
                                            VAT:</Col>
                                        <Col sm="6">
                                            {priceFormatter(this.props.getInvoice.invoice.invoiceTaxList[0].taxAmount, this.props.getInvoice.invoice)}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="6">
                                            Total: </Col>
                                        <Col sm="6">
                                            {priceFormatter(this.props.getInvoice.invoice.grandTotalAmount, this.props.getInvoice.invoice)}
                                        </Col>
                                    </Row>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                    <Row>
                        <NotesAndAttachments noteList={this.props.getInvoice.invoice.noteList} attachmentList={this.props.getInvoice.invoice.attachmentList} recordId={this.props.match.params.billid} tableName={"BILL_Invoices_Penalties_V"}/>
                    </Row>
            </div>) : (<Loading/>);
    }
}


export default graphql(getInvoiceQuery, {
    name: 'getInvoice',
    options: props => ({

        variables: { where: "id = '" + props.match.params.billid + "'", orderBy: "id" }
    }),
})(withRouter(ReadingsDetail));
